import { Fragment, useState } from 'react';
import Down from '../../../../assets/images/chevron-down.svg';
import Up from '../../../../assets/images/chevron-up.svg';
import Minus from '../../../../assets/images/minus-circle.svg';
import { ModalPortal } from '../../../ModalPortal';
import { CustomModal } from '../../../../shared/CustomModal';
import { AddToSection } from './AddToSection';
import { useDispatch } from 'react-redux';
import { moveStudents, removeStudent } from '../../../../Store/api/classApi';
import { toast } from 'react-toastify';
import { CustomSelect } from '../../../../shared/CustomSelect';

const dateOptions = {
  month: 'short',
  day: 'numeric',
  year: 'numeric',
  hour: 'numeric',
  minute: 'numeric',
  hour12: true,
};

const indicatorSeparatorStyle = {
  alignSelf: 'stretch',
  marginBottom: 8,
  marginTop: 8,
  width: 0,
};

const IndicatorSeparator = ({ innerProps }) => {
  return <span style={indicatorSeparatorStyle} {...innerProps} />;
};
export const StudentTable = ({ isLoading, sections = [], expandedSections = [], expandSection, classDetail = {}, setRefetchStudent }) => {
  const disptach = useDispatch();
  const [current, setCurrent] = useState({});
  const [loader, setLoader] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showMoveModal, setMoveModal] = useState(false);
  const [currentSection, setCurrentSection] = useState({});
  const [_, setSelectedSections] = useState([]);
  const [selectedStudents, setSelectedStudents] = useState([]);

  const selectSection = (section, checked) => {
    if (checked) {
      setSelectedStudents((prev) => [
        ...prev,
        ...section.students.map((item) => ({
          ...item,
          sectionId: section.sectionId,
        })),
      ]);
      setSelectedSections((old) => [...old, section]);
    } else {
      setSelectedStudents((prev) => prev.filter((item) => item.sectionId !== section.sectionId));
      setSelectedSections((old) => old.filter((item) => item.sectionId !== section.sectionId));
    }
  };
  const selectStudent = (student, section, checked) => {
    if (checked) {
      setSelectedStudents((old) => [...old, { ...student, sectionId: section.sectionId }]);
    } else {
      setSelectedStudents((old) => old.filter((item) => item._id !== student._id));
    }
  };
  const onToggle = () => {
    showModal && setCurrent({});
    setShowModal((prev) => !prev);
  };
  const onMoveToggle = () => {
    setMoveModal((prev) => !prev);
  };
  const handleRemove = (student) => {
    setCurrent(student);
    onToggle();
  };

  const onAction = () => {
    setLoading(true);
    disptach(
      removeStudent({
        studentId: current._id,
        sectionId: current.sectionId,
        onSuccess: () => {
          onToggle();
          setRefetchStudent(prev => !prev);
          toast.success('Student removed from section successfully.');
          setLoading(false);
        },
        onError: () => {
          toast.error('Error while removing student from section.');
          setLoading(false);
        },
      })
    );
  };

  const onMoveStudentAction = () => {
    setLoader(true);
    disptach(
      moveStudents({
        body: {
          sectionId: currentSection.value,
          studentIds: selectedStudents.map((item) => item._id),
        },
        onSuccess: () => {
          onMoveToggle();
          setRefetchStudent(prev => !prev);
          toast.success('Student moved to selected section successfully.');
          setSelectedStudents({});
          setLoader(false);
        },
        onError: () => {
          toast.error('Error while moving students to section.');
          setLoader(false);
        },
      })
    );
  };

  return (
    <>
      <ModalPortal>
        <CustomModal is_delete className='gap-4' loading={loading} onHide={onToggle} onAction={onAction} showModal={showModal} cancelBtnText='Go back' actionBtnText='Drop student' title='drop student from class?'>
          <p className='mb-0'>
            Are you sure you want to remove <b>{`${current?.firstName} ${current.lastName} `}</b>from
            <b>{` ${classDetail?.courseName} ${classDetail?.courseNumber} | Section ${current.sectionNumber} `}</b>
            and revoke all access to this classroom? You can add them back at anytime.
          </p>
        </CustomModal>
      </ModalPortal>
      <ModalPortal>
        <CustomModal loading={loader} className='gap-3' onHide={onMoveToggle} cancelBtnText='Go back' showModal={showMoveModal} actionBtnText='Move student' onAction={onMoveStudentAction} title='move students to another section'>
          <div className='d-flex flex-column justify-content-center w-100 gap-3'>
            <div className='d-flex justify-content-between align-items-center w-100'>
              <h3 className='m-0 f-16'>Select section</h3>
              <div className='form-group mb-0 w-50'>
                <CustomSelect
                  isClearable={false}
                  customStyle={{
                    control: (base, state) => ({
                      ...base,
                      border: 'none !important',
                      background: '#fafaf9',
                      boxShadow: 'none',
                      borderBottom: state.isFocused ? '1px solid #2e2e2d !important' : '1px solid #2e2e2d !important',
                      '&:hover': {
                        borderBottom: '1px solid #2e2e2d', // Keep border on hover
                      },
                    }),
                    menu: (provided) => ({
                      ...provided,
                      marginTop: 0, // This removes the gap between control and dropdown
                      border: "1px solid grey"
                    }),
                  }}
                  className='w-100 mb-0'
                  placeholder='Select section'
                  value={sections
                    .filter((item) => item.sectionId === currentSection?.value)
                    ?.map((item) => ({
                      label: `Section ${item.sectionNumber.split('-')?.[0]}`,
                      value: item.sectionId,
                    }))}
                  options={sections.filter(item => item.sectionId !== expandedSections?.[0]?._id).map((item) => ({
                    label: `Section ${item.sectionNumber.split('-')?.[0]}`,
                    value: item.sectionId,
                  }))}
                  handleChange={(value) => {
                    setCurrentSection(value);
                  }}
                  components={{ IndicatorSeparator }}
                />
              </div>
            </div>
            <div className='d-flex flex-wrap gap-3'>
              {selectedStudents.map((item) => (
                <Fragment key={item._id}>
                  <div className='d-flex align-items-center gap-2 st-move-tags'>
                    <p className=' m-0 fs-14'>{`${item.firstName} ${item.lastName}`}</p>
                    <img className='cursor' src='/assets/images/cross.png' alt='cross icon here' width={18} height={18} />
                  </div>
                </Fragment>
              ))}
            </div>
          </div>
        </CustomModal>
      </ModalPortal>
      {isLoading ? (
        <tbody>
          <tr>
            <td className='py-20'>Loading...</td>
          </tr>
        </tbody>
      ) : (
        <tbody>
          {sections.map((section) => (
            <Fragment key={section?.sectionId}>
              <tr className='header_row'>
                <td className='w-25'>Section {section.sectionNumber.split('-')[0]}</td>
                <td className='w-25'>{`${section.students.length} Students`}</td>
                <td className='w-25'></td>
                <AddToSection {...{ ...section }} />
                <td className='w-99 p-2 cursor'>
                  <p className='mb-0' onClick={onMoveToggle}>
                    <img className='class_email' src='/assets/images/move.svg' alt='move ico' width={22} height={22} /> Move
                  </p>
                </td>
                <td className='d-flex justify-content-between align-items-center'>
                  <label className='custom_colored_checkbox bottom-0' style={{ borderColor: 'transparent' }}>
                    All
                    <input
                      name='some'
                      type='checkbox'
                      disabled={expandedSections?.[0]?._id !== section.sectionId}
                      checked={(selectedStudents.length && selectedStudents.length === expandedSections?.[0]?.students?.length)}
                      onChange={(e) => {
                        e.stopPropagation();
                        selectSection(section, e.target.checked);
                      }}
                    />
                    <span className={`${expandedSections?.[0]?._id !== section.sectionId ? 'bg-grey-300': ''} checkmark`}></span>
                  </label>
                  <img
                    src={expandedSections?.[0]?._id === section._id ? Up: Down}
                    alt='expand'
                    onClick={() => {
                      expandSection(section);
                      setSelectedStudents([]);
                      setSelectedSections([]);
                    }}
                    className='cursor down'
                  />
                </td>
              </tr>
              {expandedSections.includes(section) && (
                <Fragment>
                  {section.students.map((student) => (
                    <tr className='sub_rows' key={student._id}>
                      <td className="w-25">{`${student.firstName} ${student.lastName} ${(student?.Pronounces || student?.pronouns) ? `(${student?.Pronounces || student?.pronouns})`: ""}`}</td>
                      <td className='w-25'>{student.email}</td>
                      <td className='w-25'>{student.latestActivityAnswer && student.latestActivityAnswer.length > 0 ? new Date(student.latestActivityAnswer[0].createdAt).toLocaleString('en-US', dateOptions).toUpperCase().replace(/,/g, '') : '--'}</td>
                      <td className='w-99 p-2 cursor'></td>
                      <td className='w-99 p-2 cursor'></td>
                      <td className='d-flex justify-content-between align-items-center'>
                        <label className='custom_colored_checkbox ps-1 border-transparent' style={{ zIndex: '0' }}>
                          <input
                            name='checkmark'
                            type='checkbox'
                            checked={!!(selectedStudents.find((item) => item._id === student._id))}
                            onChange={(e) => {
                              selectStudent(student, section, e.target.checked);
                            }}
                          />
                          <span className='checkmark left-1'></span>
                        </label>
                        <img
                          alt='drop'
                          width={22}
                          height={22}
                          src={Minus}
                          className='cursor border-transparent'
                          onClick={(event) => {
                            event.stopPropagation();
                            handleRemove({ ...student, sectionId: section._id, sectionNumber: section.sectionNumber });
                          }}
                        />
                      </td>
                    </tr>
                  ))}
                </Fragment>
              )}
            </Fragment>
          ))}
        </tbody>
      )}
    </>
  );
};
